
class Throw {
    public message(text: string): never {
        throw new Error(text);
    }
}

export default new Throw();
